import { useI18n } from "@/i18n/I18nProvider";

const DataProcessingAddendum = () => {
  const { t, tx } = useI18n();
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">{t('legal.dpa.title', 'Data Processing Addendum (DPA)')}</h1>
      <p className="text-gray-700 mb-4">{t('legal.dpa.intro', 'This DPA forms part of the Terms and governs the processing of personal data by Halomora on behalf of customers.')}</p>
      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">{t('legal.dpa.subp_title', 'Sub-processors')}</h2>
      <ul className="list-disc ml-6 text-gray-700 space-y-2">
        <li>{t('legal.dpa.subp.supabase', 'Supabase (database and authentication)')}</li>
        <li>{t('legal.dpa.subp.vercel', 'Vercel or Netlify (hosting)')}</li>
        <li>{t('legal.dpa.subp.sentry', 'Sentry (error monitoring) — optional')}</li>
      </ul>
      <p className="text-gray-600 mt-8">{tx('legal.last_updated', { date: today })}</p>
    </div>
  );
};

export default DataProcessingAddendum;
